import Grid from "@mui/material/Grid2";

const ThresholdValue = ({
  value,
  highlighted
}: {
  value: string;
  highlighted: boolean;
}) => {
  return (
    <Grid container justifyContent={"flex-end"}>
      <Grid
        sx={
          highlighted
            ? {
                padding: "4px",
                color: "secondary.dark",
                backgroundColor: "error.light"
              }
            : undefined
        }
      >
        {value}
      </Grid>
    </Grid>
  );
};

export default ThresholdValue;
